/** Istilah operasional delman gudang — konsisten di seluruh PWA HP delman gudang. */
export const delmanTerms = {
  appName: 'Superoti Delman Gudang',
  modules: {
    trip: 'Sesi kirim',
    materialReturn: 'Retur bahan',
  },
  activation: {
    title: 'Aktivasi HP delman gudang',
    subtitle: 'Masukkan kode aktivasi sekali pakai dari Admin HO.',
    codeLabel: 'Kode aktivasi',
    codeHelper: 'Ketik atau tempel 6 karakter dari Admin HO (tanpa strip).',
    footer: 'Belum punya kode? Hubungi Admin HO.',
    cta: 'Aktivasi',
    verifying: 'Memverifikasi…',
    success: 'Perangkat teraktivasi',
    wrongDeviceType: 'Kode ini bukan untuk HP delman gudang.',
    activateFailed: 'Aktivasi gagal. Coba lagi.',
  },
  login: {
    title: 'Login PIN',
    subtitle: 'Masukkan PIN 6 digit untuk mulai sesi kirim.',
    helper: 'Isi 6 digit PIN untuk lanjut.',
    submit: 'Masuk',
    submitting: 'Memverifikasi…',
    roleNotAllowed: 'Role tidak diizinkan login di HP delman gudang.',
  },
  trip: {
    pageTitle: 'Sesi kirim hari ini',
    subtitle: (delmanName: string) => delmanName,
    refreshAria: 'Muat ulang sesi kirim',
    loading: 'Memuat sesi kirim…',
    retry: 'Coba lagi',
    loadError: 'Gagal memuat sesi kirim.',
    emptyTitle: 'Belum ada sesi kirim',
    emptyDescription: 'Sesi kirim muncul setelah kepala gudang menyerahkan pengiriman ke kamu.',
    tripCode: (code: string) => code,
    dispatchCount: (count: number) => `${count} pengiriman`,
    back: 'Kembali',
    progressDapur: (done: number, total: number) => `${done}/${total} dapur`,
    materialsCount: (count: number) => `${count} bahan`,
    showAllMaterials: 'Lihat semua',
    hideMaterials: 'Sembunyikan',
    status: {
      dispatched: 'Siap dimulai',
      in_progress: 'Sedang berjalan',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
    } as Record<string, string>,
    dispatchStatus: {
      dispatched: 'Siap',
      in_transit: 'Dalam transit',
      receiving_draft: 'Diterima dapur (draft)',
      receiving_completed: 'Selesai diterima',
      cancelled: 'Dibatalkan',
    } as Record<string, string>,
    start: 'Mulai kirim',
    starting: 'Memulai…',
    startSuccess: 'Sesi kirim dimulai.',
    startFailed: 'Gagal memulai sesi kirim.',
    complete: 'Selesaikan sesi',
    completing: 'Menyelesaikan…',
    completeConfirmTitle: 'Selesaikan sesi kirim ini?',
    completeConfirmDescriptionOpen:
      'Masih ada dapur yang belum selesai diterima. Sisa bahan yang belum diterima akan dikembalikan ke gudang.',
    completeConfirmDescriptionAllDone:
      'Semua dapur sudah selesai. Selesaikan sesi kirim ini?',
    completeConfirmYes: 'Ya, selesaikan',
    completeConfirmCancel: 'Batal',
    completeSuccess: 'Sesi kirim selesai.',
    completeFailed: 'Gagal menyelesaikan sesi kirim.',
    generateQr: 'Buat QR handover',
    regenerateQr: 'Buat ulang QR',
    generatingQr: 'Membuat QR…',
    generateQrFailed: 'Gagal membuat QR handover.',
    qrExpiresIn: (label: string) => `Berlaku ${label}`,
    qrExpired: 'QR kedaluwarsa — buat ulang.',
    qrHint: 'Tunjukkan QR ini ke kepala dapur untuk verifikasi serah terima.',
    qrPayloadHint: 'Jika QR tidak terbaca, tempel kode ini di App Dapur (input manual).',
    copyPayload: 'Salin kode',
    copyPayloadSuccess: 'Kode disalin.',
    copyPayloadFailed: 'Gagal menyalin kode.',
    fullscreen: 'Layar penuh',
    fullscreenClose: 'Tutup layar penuh',
    fullscreenDialogAria: 'QR handover layar penuh',
    materialLine: (name: string, uom: string, qty: number) => `${name} · ${qty} ${uom}`,
  },
  materialReturn: {
    pageTitle: 'Retur bahan dari dapur',
    subtitle: (delmanName: string) => delmanName,
    intro: 'Scan QR retur dari kepala dapur untuk pickup, lalu terima barang di gudang dengan PIN delman.',
    refreshAria: 'Muat ulang daftar retur',
    loading: 'Memuat retur…',
    retry: 'Coba lagi',
    loadError: 'Gagal memuat retur bahan.',
    backToList: 'Kembali ke daftar',
    scanPickupCta: 'Scan pickup retur',
    scanTitle: 'Scan QR retur dapur',
    scanHint: 'Kepala dapur tampilkan QR retur ke gudang — scan untuk pickup.',
    scanConfirm: 'Konfirmasi pickup',
    scanProcessing: 'Memproses pickup…',
    liveBadge: 'Live',
    cameraHint: 'Arahkan kamera ke QR retur dari App Dapur',
    cameraUnsupported: 'Kamera QR tidak didukung di browser ini — tempel kode manual di bawah.',
    cameraPermissionDenied: 'Izinkan akses kamera di pengaturan browser untuk scan QR.',
    manualToggle: 'Input manual kode QR',
    pasteLabel: 'Tempel kode QR retur',
    pastePlaceholder: 'SUPEROTI:WRH:<return_id>:<token>',
    pickedUpTitle: (count: number) => `Menunggu terima di gudang (${count})`,
    validatedTitle: 'Sudah diterima di gudang',
    fromKitchen: (kitchen: string) => `Dari ${kitchen}`,
    receiveCta: 'Terima di gudang →',
    receiveHint: 'Qty terima harus sama dengan qty retur dari dapur.',
    receiveConfirm: 'Terima dengan PIN',
    emptyTitle: 'Belum ada retur hari ini',
    emptyDescription: 'Retur muncul setelah kepala dapur publish retur ke gudang.',
    pinTitle: 'PIN konfirmasi terima',
    pinDescription: (code: string, kitchen: string) => `Terima retur ${code} dari ${kitchen} ke stok gudang.`,
    pinFallback: 'Masukkan PIN delman.',
    status: {
      ready_for_pickup: 'Siap pickup',
      picked_up: 'Dalam transit',
      validated: 'Selesai',
    } as Record<string, string>,
    summary: {
      join: (parts: string[]) => parts.join(' · '),
      materialCount: (count: number) => `${count} material`,
    },
    toast: {
      scanRequired: 'Masukkan atau scan kode QR retur.',
      invalidQr: 'QR bukan retur ke gudang (harus SUPEROTI:WRH:…).',
      pickupSuccess: (code: string) => `Pickup retur ${code} berhasil.`,
      pickupFailed: 'Pickup retur gagal.',
      receiveSuccess: (code: string) => `Retur ${code} diterima di gudang.`,
      incompleteData: 'Data retur tidak lengkap.',
    },
  },
} as const
